module.exports = "<ot-loader ng-show=\"vm.session.getData().isLoadingPrivateEvents()\"></ot-loader>\n<ul infinite-scroll='vm.loadMore(params.type)' class=\"ot-event-list\" ng-class=\"{\n  'ot-event-landing-style': params.type == 'landing',\n  'ot-event-manage-style': params.type == 'manage',\n  'ot-event-compact-style': params.type == 'compact'\n}\">\n  <li ng-repeat=\"event in params.items track by $index\">\n    <ot-event params=\"{'item': event, 'type': $parent.params.type}\"></ot-event>\n  </li>\n</ul>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/content/eventList.html
 ** module id = 262
 ** module chunks = 1
 **/